/**
 * FSIcon icon set component. This file should be AutoGenerated from generate_react_native_vector_icon_class.rb
 * Usage: <FSIcon name="icon-name" size={20} color="#4F8EF7" />
 *
 * @providesModule FSIcon
 */
"use strict"
import { createIconSetFromIcoMoon } from "react-native-vector-icons"
import icoMoonConfig from "app/assets/fonts/FSIcon/selection.json"
import React from "react"

const FSIcon = createIconSetFromIcoMoon(icoMoonConfig, "FSIcon")

var disableFontScaling = ComposedComponent =>
  class extends React.Component {
    render() {
      return (
        <ComposedComponent
          {...this.props}
          allowFontScaling={false}
          textPropsIOS={{ allowFontScaling: false }}
        />
      )
    }
  }

export default disableFontScaling(FSIcon)
